import React from "react";

const Pagination = ({ setPage, onPageChange, totalPages, page, maxVisiblePages = 5 }) => {
  const getPaginationRange = () => {
    const range = [];
    const visibleMiddlePages = maxVisiblePages - 2; // Deduct slots for first and last pages
    const halfRange = Math.floor(visibleMiddlePages / 2);

    if (totalPages <= maxVisiblePages) {
      // If total pages are less than or equal to maxVisiblePages, show all
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      // Always include the first page
      range.push(1);

      // Calculate middle range
      let startPage = Math.max(2, page - halfRange);
      let endPage = Math.min(totalPages - 1, page + halfRange);

      // Adjust range to always display `maxVisiblePages`
      if (page <= halfRange + 1) {
        // If near the start, shift range forward
        endPage = Math.min(totalPages - 1, visibleMiddlePages + 1);
      } else if (page >= totalPages - halfRange) {
        // If near the end, shift range backward
        startPage = Math.max(2, totalPages - visibleMiddlePages);
      }

      // Add ellipses and middle pages
      if (startPage > 2) {
        range.push("...");
      }
      for (let i = startPage; i <= endPage; i++) {
        range.push(i);
      }
      if (endPage < totalPages - 1) {
        range.push("...");
      }

      // Always include the last page
      range.push(totalPages);
    }

    return range;
  };

  const paginationRange = getPaginationRange();

  return (
    <div className="profile-pagination">
      {/* Previous Button */}
      <div
        className="glass-effect pager"
        onClick={() => onPageChange("prev")}
        disabled={page === 1}
      >
        <img src="/icons/paginationLeft.svg" alt="Prev" />
      </div>

      {/* Page Numbers */}
      {paginationRange.map((item, index) => (
        <div
          key={index}
          className={`glass-effect pager ${
            item === page ? "button-purple" : ""
          }`}
          onClick={() => typeof item === "number" && setPage(item)}
        >
          {item}
        </div>
      ))}

      {/* Next Button */}
      <div
        className="glass-effect next-btn pager"
        onClick={() => onPageChange("next")}
        disabled={page === totalPages}
      >
        <img src="/icons/paginationLeft.svg" alt="Next" />
      </div>
    </div>
  );
};

export default Pagination;
